import { Pipe } from '@angular/core';
var CapitalizePipe = (function () {
    function CapitalizePipe() {
    }
    CapitalizePipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!value) {
            return "";
        }
        var str = value.split(" ");
        for (var i = 0, x = str.length; i < x; i++) {
            str[i] = (str[i][0] || "").toUpperCase() + str[i].substr(1);
        }
        return str.join(" ");
    };
    CapitalizePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'capitalize',
                },] },
    ];
    /** @nocollapse */
    CapitalizePipe.ctorParameters = function () { return []; };
    return CapitalizePipe;
}());
export { CapitalizePipe };
//# sourceMappingURL=capitalize.js.map


//////////////////
// WEBPACK FOOTER
// ../ionic-commons/dist/pipes/capitalize.js
// module id = 388
// module chunks = 0